import React from 'react';
import Icon from '../../../components/AppIcon';

const MetricItem = ({ title, value, subtitle, icon, color, trend }) => {
  const colorMap = {
    blue: 'bg-blue-500/10 text-blue-500',
    amber: 'bg-amber-500/10 text-amber-500',
    emerald: 'bg-emerald-500/10 text-emerald-500',
    violet: 'bg-violet-500/10 text-violet-500',
  };

  return (
    <div className="bg-card border border-border rounded-2xl p-4 flex flex-col gap-3">
      <div className="flex items-center justify-between">
        <div className={`w-10 h-10 rounded-xl flex items-center justify-center ${colorMap?.[color] || colorMap?.blue}`}>
          <Icon name={icon} size={20} />
        </div>
        {trend !== undefined && (
          <div className={`flex items-center gap-1 text-xs font-medium ${trend >= 0 ? 'text-emerald-500' : 'text-red-500'}`}>
            <Icon name={trend >= 0 ? 'TrendingUp' : 'TrendingDown'} size={14} />
            <span>{Math.abs(trend)}%</span>
          </div>
        )}
      </div>
      <div>
        <p className="text-2xl font-bold text-foreground leading-none mb-1">{value}</p>
        <p className="text-sm font-medium text-foreground/80">{title}</p>
        {subtitle && <p className="text-xs text-muted-foreground mt-0.5">{subtitle}</p>}
      </div>
    </div>
  );
};

const MobileMetricsCards = ({ metrics, loading }) => {
  if (loading) {
    return (
      <div className="grid grid-cols-2 gap-3">
        {[1, 2, 3, 4]?.map(i => (
          <div key={i} className="bg-card border border-border rounded-2xl p-4 h-28 animate-pulse">
            <div className="w-10 h-10 bg-muted rounded-xl mb-3" />
            <div className="h-6 bg-muted rounded w-12 mb-1" />
            <div className="h-3 bg-muted rounded w-20" />
          </div>
        ))}
      </div>
    );
  }

  const cards = [
    {
      title: 'Active Projects',
      value: metrics?.activeProjects ?? '—',
      subtitle: metrics?.activeProjectsSubtitle || '',
      icon: 'Briefcase',
      color: 'blue',
      trend: metrics?.projectsTrend,
    },
    {
      title: 'Open Bids',
      value: metrics?.openBids ?? '—',
      subtitle: metrics?.openBidsSubtitle || '',
      icon: 'FileText',
      color: 'amber',
      trend: metrics?.bidsTrend,
    },
    {
      title: 'Resources Available',
      value: metrics?.resourcesAvailable ?? '—',
      subtitle: metrics?.resourcesSubtitle || '',
      icon: 'Package',
      color: 'emerald',
      trend: undefined,
    },
    {
      title: 'Prospects',
      value: metrics?.prospects ?? '—',
      subtitle: metrics?.prospectsSubtitle || '',
      icon: 'Target',
      color: 'violet',
      trend: metrics?.prospectsTrend,
    },
  ];

  return (
    <div className="grid grid-cols-2 gap-3">
      {cards?.map((card, idx) => (
        <MetricItem key={idx} {...card} />
      ))}
    </div>
  );
};

export default MobileMetricsCards;
